import { useTheme } from 'styled-components';
import { useDocumentsInlineViewerContext } from './DocumentsInlineViewerContext';

/**
 * Custom hoom per controllare se è presente un viewer inline per i documenti.
 */
export function useHasDocumentsInlineViewer() {
  const theme = useTheme();
  const { isEnabled } = useDocumentsInlineViewerContext();

  return isEnabled && theme?.enablePdfDrawer;
}
